<template>
  <commonQueryInput
    :inputItems="multiInputItems"
    v-model:getValue="multiInputVal"
  ></commonQueryInput>
  <div class="text-end mt-3">
    <button
      type="button"
      class="btn p-0"
      style="
        color: #fff;
        background-color: #4b8c80;
        width: 7rem;
        height: 2rem;
        font-size: 1.125rem;
      "
      @click="addCompany"
    >
      廠商建檔
    </button>
  </div>
  <div class="manufacInfoTable-div table-responsive mt-3 mx-0">
    <table class="manufacInfoTable-table table table-style">
      <thead class="table-head-theme-green">
        <tr class="stickyHeader">
          <th
            v-for="manufacInfoTableField in manufacInfoTableFields"
            :class="manufacInfoTableField.class"
          >
            {{ manufacInfoTableField.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="(manufacInfoTableItem, itemKey) in manufacInfoTableItems"
        >
          <template
            v-for="(detailItem, detailKey) in manufacInfoTableItem.detail"
          >
            <tr v-if="detailKey == 0">
              <td
                style="cursor: pointer"
                :rowspan="manufacInfoTableItem.detail.length"
                @click="companyRowClick(manufacInfoTableItem)"
              >
                {{ manufacInfoTableItem.companyName }}
              </td>
              <td>
                {{
                  detailItem.contactPerson == ""
                    ? "-"
                    : detailItem.contactPerson
                }}
              </td>
              <td>
                {{
                  manufacInfoTableItem.telephone === ""
                    ? "-"
                    : `${manufacInfoTableItem.telephone}${
                        detailItem.ext !== "" ? ` #${detailItem.ext}` : ""
                      }`
                }}
              </td>
              <td>{{ detailItem.phone == "" ? "-" : detailItem.phone }}</td>
              <td>
                {{
                  manufacInfoTableItem.fax == ""
                    ? "-"
                    : manufacInfoTableItem.fax
                }}
              </td>
              <td>
                {{
                  manufacInfoTableItem.address == ""
                    ? "-"
                    : manufacInfoTableItem.address
                }}
              </td>
              <td>{{ detailItem.mail == "" ? "-" : detailItem.mail }}</td>
              <td>{{ detailItem.note == "" ? "-" : detailItem.note }}</td>
            </tr>
            <tr v-else>
              <td style="border-left: none">
                {{
                  detailItem.contactPerson == ""
                    ? "-"
                    : detailItem.contactPerson
                }}
              </td>
              <td>
                {{
                  manufacInfoTableItem.telephone === ""
                    ? "-"
                    : `${manufacInfoTableItem.telephone}${
                        detailItem.ext !== "" ? ` #${detailItem.ext}` : ""
                      }`
                }}
              </td>
              <td>{{ detailItem.phone == "" ? "-" : detailItem.phone }}</td>
              <td>
                {{
                  manufacInfoTableItem.fax == ""
                    ? "-"
                    : manufacInfoTableItem.fax
                }}
              </td>
              <td>
                {{
                  manufacInfoTableItem.address == ""
                    ? "-"
                    : manufacInfoTableItem.address
                }}
              </td>
              <td>{{ detailItem.mail == "" ? "-" : detailItem.mail }}</td>
              <td>{{ detailItem.note == "" ? "-" : detailItem.note }}</td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, inject, ref, watch } from "vue";
import store from "@/store";
export default {
  components: { commonQueryInput, commonTable },
  setup() {
    const commonMethods = inject("commonMethods");
    const manufacInfoTableFields = inject("manufacInfoTableFields");
    const manufacInfoTableItems = inject("manufacInfoTableItems");
    const firm = inject("firm");
    const mod = inject("mod");

    const firmCategory = computed(
      () => store.getters["selectOptions/get_firmCategory"]
    );

    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "firm",
        label: "廠商類別",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇類別 --",
        options: firmCategory,
      },
    ]);

    const addCompany = commonMethods.addCompany;
    const companyRowClick = commonMethods.companyRowClick;
    const queryFirmInfo = commonMethods.queryFirmInfo;
    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        mod.value = false;
        console.log(newValue);
        firm.value = newValue["firm"];

        queryFirmInfo();
      },
      { deep: true }
    );

    return {
      multiInputVal,
      multiInputItems,
      manufacInfoTableFields,
      manufacInfoTableItems,
      addCompany,
      companyRowClick,
    };
  },
};
</script>

<style></style>

<style scoped>
.manufacInfoTable-div {
  overflow-y: auto;
  max-height: 450px;
}
.manufacInfoTable-table.table-style td,
.manufacInfoTable-table.table-style th {
  font-size: 16px;
}
.manufacInfoTable-table.table-style th:nth-child(1) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(2) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(3) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(4) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(5) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(6) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(7) {
  min-width: 120px;
}
.manufacInfoTable-table.table-style th:nth-child(8) {
  min-width: 120px;
}
</style>
